import _ from 'lodash'
import { AUTH_EXPIRED_MESSAGE, isAuthExpiredError } from './auth-session'

export const arrayToSentence = (arr, separator = ', ', lastSeparator = ' and ') => {
  if (!arr) {
    return ''
  }

  if (arr.length === 0) {
    return ''
  }

  if (arr.length === 1) {
    return arr[0]
  }

  return arr.slice(0, -1).join(separator) + lastSeparator + arr[arr.length - 1]
}

export const userStatusFormatter = (status = '', user = {}) => {
  if (status === 'active' && user.isDeactivationPending) {
    return 'Pending Deactivation'
  }

  if (status === 'email_sent') {
    return 'Pending Activation'
  }

  if (status === 'accessible_termination' && user.secondaryEmail) {
    return `Email Access`
  }

  if (status === 'accessible_termination') {
    return 'Email Access'
  }

  return _.capitalize(status)
}

export const parseErrorMessage = (errResponse, defaultMessage = 'Server Error. Please try again in a few moments.') => {
  if (isAuthExpiredError(errResponse)) {
    return AUTH_EXPIRED_MESSAGE
  }

  let errorMessage = _.get(errResponse, 'response.data.data', null)
  if (typeof errorMessage === 'object') {
    errorMessage = _.values(errorMessage)[0]
  }

  return errorMessage || defaultMessage
}

export const formatPhoneWithDashes = (phone) => {
  if (!phone) {
    return ''
  }

  const onlyNumbers = phone.replace(/\D/g, '')
  return `${onlyNumbers.substr(0, 3)}-${onlyNumbers.substr(3, 3)}-${onlyNumbers.substr(6, 4)}`
}

export const ensureHttpProtocol = (url) => {
  if (!url) {
    return ''
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }

  return `https://${url}`
}
